import "swiper/swiper-bundle.css";
import "../css/index.scss";
import * as core from "./app/core";

//startup functions
core.startUp();
